import {
  Container,
  PageHeader,
  ContentSection,
  ContentContainer,
  SectionTitle,
  SubsectionTitle,
  TextContent,
  ImportantNotice,
  LastUpdated,
} from "./TermsOfServicePage.styles";
import MainContainer from "../../components/MainContainer/MainContainer";
import SEO from "../../components/SEO/SEO";

const TermsOfServicePage = () => {
  return (
    <MainContainer>
      <SEO
        title="Uslovi korišćenja"
        description="Uslovi korišćenja MITOVKA BeautySpot online platforme za edukacije."
        path="/uslovi-koriscenja"
      />

      <Container>
        <PageHeader>
          <h1>Uslovi Korišćenja</h1>
          <p>
            Molimo vas da pažljivo pročitate sledeće uslove korišćenja pre
            korišćenja naših usluga i kurseva.
          </p>
        </PageHeader>

        <ContentSection>
          <ContentContainer>
            <SectionTitle>1. Opšti Uslovi</SectionTitle>
            <TextContent>
              <p>
                Dobrodošli na MITOVKA Beautyspot platformu. Korišćenjem naših
                usluga, pristupanjem našoj veb stranici ili kupovinom naših
                kurseva, prihvatate da budete vezani ovim uslovima korišćenja.
              </p>
              <p>
                MITOVKA Beautyspot zadržava pravo da izmeni ove uslove u bilo
                kom trenutku. Sve izmene će biti objavljene na ovoj stranici sa
                naznačenim datumom poslednje izmene. O značajnim promenama ćemo
                vas obavestiti putem email-a najmanje 30 dana pre stupanja na
                snagu.
              </p>
              <p>
                Nastavljajući da koristite platformu nakon objave izmena,
                prihvatate nove uslove korišćenja.
              </p>
            </TextContent>

            <SectionTitle>2. Registracija i Nalog</SectionTitle>
            <TextContent>
              <p>
                Za pristup određenim funkcijama platforme, potrebno je da
                kreirate nalog. Obavezujete se da:
              </p>
              <ul>
                <li>
                  Pružite tačne, potpune i ažurne informacije o sebi prilikom
                  registracije
                </li>
                <li>
                  Održavate bezbednost svog naloga i lozinke - ne delite
                  pristupne podatke
                </li>
                <li>
                  Odmah nas obavestite o bilo kakvoj neovlašćenoj upotrebi vašeg
                  naloga
                </li>
                <li>
                  Prihvatate potpunu odgovornost za sve aktivnosti koje se
                  dešavaju pod vašim nalogom
                </li>
                <li>
                  Budete stariji od 16 godina ili imate saglasnost roditelja/
                  staratelja
                </li>
                <li>
                  Koristite samo jedan nalog - kreiranje više naloga je
                  zabranjeno
                </li>
              </ul>
              <p>
                Zadržavamo pravo da suspendujemo ili obrišemo naloge koji krše
                ove uslove ili pokazuju sumnjive aktivnosti.
              </p>
            </TextContent>

            <SectionTitle>3. Kursevi i Sadržaj</SectionTitle>
            <SubsectionTitle>3.1 Pristup Kursevima</SubsectionTitle>
            <TextContent>
              <p>
                Kupovinom kursa dobijate ličnu, neprenosivu, neekskluzivnu
                licencu za pristup sadržaju kursa. Ova licenca je:
              </p>
              <ul>
                <li>
                  <strong>Neprenošiva:</strong> ne možete preneti pristup drugoj
                  osobi ili deliti pristupne podatke
                </li>
                <li>
                  <strong>Ograničena:</strong> može se koristiti samo za lično,
                  nekomercijalno učenje
                </li>
                <li>
                  <strong>Revokabilna:</strong> možemo je opozvati u slučaju
                  kršenja uslova korišćenja
                </li>
                <li>
                  <strong>Trajna:</strong> pristup kursu je dozvoljen bez
                  vremenskog ograničenja osim ako nije drugačije navedeno
                </li>
              </ul>
              <p>MITOVKA Beautyspot zadržava pravo da:</p>
              <ul>
                <li>Ažurira i poboljšava sadržaj kurseva</li>
                <li>Dodaje nove lekcije i materijale</li>
                <li>Privremeno obustavlja pristup zbog tehničkog održavanja</li>
                <li>
                  Povuče kurs iz ponude (uz očuvanje pristupa za postojeće
                  korisnike)
                </li>
              </ul>
            </TextContent>

            <SubsectionTitle>3.2 Autorska Prava</SubsectionTitle>
            <TextContent>
              <p>
                Sav sadržaj kurseva, uključujući ali ne ograničavajući se na
                video materijale, PDF vodiče, slike, grafike, tekstove i
                prezentacije, zaštićen je autorskim pravima i intelektualnom
                svojinom MITOVKA Beautyspot.
              </p>
              <p>Strogo je zabranjeno:</p>
              <ul>
                <li>
                  Kopiranje, reprodukovanje ili distribucija bilo kog dela
                  sadržaja
                </li>
                <li>
                  Snimanje, preuzimanje ili skladištenje video materijala van
                  platforme
                </li>
                <li>
                  Deljenje pristupnih podataka, lozinki ili naloga sa drugim
                  osobama
                </li>
                <li>
                  Javno prikazivanje, emitovanje ili izlaganje sadržaja kursa
                </li>
                <li>
                  Komercijalna upotreba naučenog sadržaja bez pisane dozvole
                </li>
                <li>Kreiranje derivativnih dela baziranih na našem sadržaju</li>
                <li>
                  Uklanjanje ili izmena oznaka autorskih prava i zaštitnih
                  znakova
                </li>
              </ul>
            </TextContent>

            <ImportantNotice>
              <div className="notice-title">Važna Napomena</div>
              <div className="notice-content">
                Kršenje autorskih prava može rezultovati trenutnim ukidanjem
                pristupa svim kursevima bez mogućnosti povraćaja sredstava, kao
                i pravnim posledicama uključujući tužbe za naknadu štete u
                skladu sa Zakonom o autorskom i srodnim pravima Republike
                Srbije.
              </div>
            </ImportantNotice>

            <SectionTitle>4. Plaćanje i Povraćaj</SectionTitle>
            <SubsectionTitle>4.1 Cene i Plaćanje</SubsectionTitle>
            <TextContent>
              <p>
                Sve cene na MITOVKA Beautyspot platformi su izražene u Srpskim
                dinarima (RSD) i uključuju porez na dodatu vrednost (PDV) po
                stopi propisanoj zakonom Republike Srbije.
              </p>
              <p>
                Plaćanje se vrši unapred putem bezbednog online plaćanja
                kartičnim putem kroz Raiffeisen Gateway sistem.
              </p>
              <p>
                <strong>Prihvaćene platne kartice:</strong>
              </p>
              <ul>
                <li>Visa</li>
                <li>MasterCard</li>
                <li>Maestro</li>
                <li>Dina</li>
              </ul>
              <p>
                <strong>Bezbednost transakcija:</strong>
              </p>
              <ul>
                <li>
                  Sve transakcije su zaštićene SSL enkripcijom i obrađuju se
                  preko Raiffeisen Gateway-a
                </li>
                <li>
                  Primenjuju se PCI DSS standardi bezbednosti platnih kartica
                </li>
                <li>
                  3D Secure autentifikacija (Verified by Visa, MasterCard
                  SecureCode) za dodatnu zaštitu
                </li>
                <li>MITOVKA Beautyspot NE čuva podatke vaše platne kartice</li>
                <li>
                  Svi podaci o kartici se obrađuju direktno preko Raiffeisen
                  banke
                </li>
              </ul>
              <p>
                <strong>Potvrda plaćanja:</strong>
              </p>
              <ul>
                <li>
                  Nakon uspešne transakcije dobićete email potvrdu sa detaljima
                  kupovine
                </li>
                <li>
                  Pristup kupljenom kursu biće omogućen odmah nakon potvrde
                  plaćanja
                </li>
                <li>
                  Fiskalni račun će biti dostupan u vašem nalogu u sekciji
                  "Kupovine"
                </li>
              </ul>
              <p>
                Zadržavamo pravo da promenimo cene kurseva u bilo kom trenutku.
                Promene cena ne utiču na već kupljene kurseve.
              </p>
            </TextContent>

            <SubsectionTitle>
              4.2 Tehnički Problemi sa Plaćanjem
            </SubsectionTitle>
            <TextContent>
              <p>U slučaju tehničkih problema tokom procesa plaćanja:</p>
              <ul>
                <li>
                  <strong>Dvostruka naplata:</strong> Ako dođe do greške i
                  sredstva budu duplo naplaćena, kontaktirajte našu podršku
                  odmah. Povraćaj će biti procesiran u roku od 3-5 radnih dana.
                </li>
                <li>
                  <strong>Neuspela transakcija:</strong> Proverite status
                  transakcije u vašoj banci ili mobilnom bankarstvu pre ponovnog
                  pokušaja plaćanja.
                </li>
                <li>
                  <strong>Blokirana sredstva:</strong> Ako su sredstva blokirana
                  tokom neuspele transakcije, banka će ih automatski vratiti u
                  roku od 3-5 radnih dana.
                </li>
                <li>
                  <strong>Nije omogućen pristup:</strong> Ako je plaćanje
                  uspešno ali pristup kursu nije omogućen, kontaktirajte našu
                  podršku sa dokazom o uplati (broj transakcije).
                </li>
              </ul>
              <p>
                Za sve probleme vezane za plaćanje, kontaktirajte našu podršku
                sa sledećim informacijama (NIKADA ne šaljite podatke platne
                kartice):
              </p>
              <ul>
                <li>Datum i vreme transakcije</li>
                <li>Iznos plaćanja</li>
                <li>Naziv kursa</li>
                <li>ID transakcije (ako je dostupan)</li>
                <li>Opis problema</li>
              </ul>
            </TextContent>

            <SectionTitle>5. Ponašanje Korisnika</SectionTitle>
            <TextContent>
              <p>
                Kao korisnik MITOVKA Beautyspot platforme, obavezujete se da
                nećete:
              </p>
              <ul>
                <li>
                  Kršiti bilo kakve važeće zakone Republike Srbije ili
                  međunarodne propise
                </li>
                <li>
                  Uznemiriti, maltretirati, pretiti ili na drugi način ugroziti
                  druge korisnike ili osoblje
                </li>
                <li>
                  Objavljivati neprikladan, uvredljiv, diskriminatorski ili
                  nezakonit sadržaj
                </li>
                <li>
                  Deliti lažne informacije ili predstavljati se kao druga osoba
                </li>
                <li>
                  Pokušavati da zaobiđete bezbednosne mere platforme ili sisteme
                  autentifikacije
                </li>
                <li>
                  Koristiti automatizovane sisteme (botove, skriptе) za pristup
                  platformi
                </li>
                <li>
                  Preopterećivati servere nepotrebnim zahtevima ili DDoS
                  napadima
                </li>
                <li>
                  Koristiti platformu za komercijalne svrhe bez pisane dozvole
                </li>
                <li>
                  Prikupljati podatke drugih korisnika bez njihove saglasnosti
                </li>
                <li>Postavljati viruse, malware ili druge štetne kodove</li>
              </ul>
              <p>Kršenje ovih pravila može rezultirati:</p>
              <ul>
                <li>Upozorenjem</li>
                <li>Privremenom suspenzijom naloga</li>
                <li>
                  Trajnim ukidanjem naloga bez mogućnosti povraćaja sredstava
                </li>
                <li>Pravnim postupkom i tužbom za naknadu štete</li>
                <li>Prijavom nadležnim organima u slučaju krivičnog dela</li>
              </ul>
            </TextContent>

            <SectionTitle>6. Ograničenje Odgovornosti</SectionTitle>
            <TextContent>
              <p>
                MITOVKA Beautyspot pruža edukacione usluge "kakve jesu" (as-is)
                i "kako je dostupno" (as-available) bez bilo kakvih garancija.
              </p>
              <p>
                <strong>Ne garantujemo da će:</strong>
              </p>
              <ul>
                <li>
                  Usluge biti dostupne 24/7 bez prekida - može doći do
                  planiranog održavanja ili tehničkih problema
                </li>
                <li>Sadržaj kurseva biti potpuno bezgrešan ili potpun</li>
                <li>
                  Rezultati učenja biti garantovani - uspeh zavisi od vašeg
                  zalaganja
                </li>
                <li>
                  Platforma biti bez grešaka - radimo na stalnom poboljšanju
                </li>
              </ul>
              <p>
                <strong>Naša odgovornost je ograničena na:</strong>
              </p>
              <ul>
                <li>
                  Maksimalni iznos koji ste platili za određeni kurs u
                  poslednjih 12 meseci
                </li>
                <li>
                  Direktnu štetu uzrokovanu našom grubom nepažnjom ili nameram
                </li>
              </ul>
              <p>
                <strong>NISMO odgovorni za:</strong>
              </p>
              <ul>
                <li>
                  Indirektnu štetu, izgubljenu dobit ili propuštenu korist
                </li>
                <li>
                  Gubitak podataka usled vaših propusta (zaboravljena lozinka)
                </li>
                <li>Probleme sa vašim internet provajderom ili uređajima</li>
                <li>Odluke koje donesete na osnovu sadržaja kurseva</li>
                <li>
                  Poslovne rezultate ili finansijski uspeh nakon završetka kursa
                </li>
                <li>
                  Neovlašćen pristup vašem nalogu zbog kompromitovane lozinke
                </li>
              </ul>
            </TextContent>

            <SectionTitle>7. Zaštita Podataka</SectionTitle>
            <TextContent>
              <p>
                Poštujemo vašu privatnost i postupamo sa ličnim podacima u
                skladu sa:
              </p>
              <ul>
                <li>Našom Politikom privatnosti</li>
                <li>GDPR (General Data Protection Regulation) standardima</li>
                <li>Zakonom o zaštiti podataka o ličnosti Republike Srbije</li>
                <li>Zakonom o elektronskoj trgovini</li>
              </ul>
              <p>
                Detaljne informacije o tome kako prikupljamo, koristimo i
                štitimo vaše podatke možete pronaći u našoj{" "}
                <a href="/privacy-policy" style={{ color: "var(--accent)" }}>
                  Politici privatnosti
                </a>
                .
              </p>
              <p>
                <strong>Vaša prava:</strong>
              </p>
              <ul>
                <li>Pravo pristupa podacima</li>
                <li>Pravo ispravke netačnih podataka</li>
                <li>Pravo brisanja podataka (uz zakonska ograničenja)</li>
                <li>Pravo ograničavanja obrade</li>
                <li>Pravo prenosivosti podataka</li>
                <li>Pravo prigovora</li>
              </ul>
            </TextContent>

            <SectionTitle>8. Prekid Usluga</SectionTitle>
            <TextContent>
              <p>
                Zadržavamo pravo da prekinemo, ograničimo ili suspendujemo
                pristup vašem nalogu i uslugama u sledećim slučajevima:
              </p>
              <ul>
                <li>
                  <strong>Kršenje uslova korišćenja:</strong> uključujući
                  kršenje autorskih prava, deljenje naloga, zloupotreba
                </li>
                <li>
                  <strong>Sumnja na neovlašćenu upotrebu:</strong> sumnjive
                  aktivnosti, pokušaji hakovanja, multiple prijave
                </li>
                <li>
                  <strong>Sumnja na prevaru:</strong> lažne informacije,
                  povraćaj sredstava nakon zloupotrebe, ukradena kartica
                </li>
                <li>
                  <strong>Zahtev nadležnih organa:</strong> sudske odluke,
                  zahtevi policije, poreske uprave
                </li>
                <li>
                  <strong>Tehnički razlozi:</strong> bezbednosni propusti,
                  održavanje sistema
                </li>
                <li>
                  <strong>Zatvaranje platforme:</strong> uz obaveštenje najmanje
                  30 dana unapred i proporcionalnim povraćajem sredstava
                </li>
              </ul>
              <p>
                <strong>Proces suspenzije:</strong>
              </p>
              <ul>
                <li>
                  Obaveštenje putem email-a sa razlogom suspenzije (osim u
                  slučajevima urgentne bezbednosne pretnje)
                </li>
                <li>Mogućnost objašnjenja ili žalbe u roku od 7 dana</li>
                <li>Konačna odluka u roku od 14 dana od prijema objašnjenja</li>
              </ul>
              <p>
                U slučaju trajnog ukidanja naloga zbog kršenja uslova, nećete
                biti u pravu za povraćaj sredstava.
              </p>
            </TextContent>

            <SectionTitle>9. Intelektualna Svojina</SectionTitle>
            <TextContent>
              <p>
                Sva intelektualna svojina na MITOVKA Beautyspot platformi,
                uključujući ali ne ograničavajući se na:
              </p>
              <ul>
                <li>Zaštitni znakovi i logotipi</li>
                <li>Dizajn platforme i korisničkog interfejsa</li>
                <li>Tekstualni sadržaj i kopija</li>
                <li>Fotografije, ilustracije i grafike</li>
                <li>Video i audio snimci</li>
                <li>Softverski kod i algoritmi</li>
                <li>Baza podataka i struktura kurseva</li>
              </ul>
              <p>
                ...je isključivo vlasništvo MITOVKA Beautyspot ili naših
                licencnih partnera.
              </p>
              <p>
                Zabranjena je upotreba bilo kog dela naše intelektualne svojine
                bez pisane dozvole, uključujući:
              </p>
              <ul>
                <li>Korišćenje našeg loga ili brenda</li>
                <li>Kopiranje dizajna platforme</li>
                <li>Reverse engineering softverskih komponenti</li>
                <li>
                  Kreiranje konkurentnih proizvoda baziranih na našem radu
                </li>
              </ul>
            </TextContent>

            <SectionTitle>10. Izmene Uslova</SectionTitle>
            <TextContent>
              <p>
                MITOVKA Beautyspot zadržava pravo da menja ove uslove korišćenja
                povremeno kako bi odražavali:
              </p>
              <ul>
                <li>Izmene u našim uslugama i funkcionalnostima</li>
                <li>Nove zakonske zahteve i regulative</li>
                <li>Unapređenja bezbednosti i privatnosti</li>
                <li>Povratne informacije korisnika</li>
              </ul>
              <p>
                <strong>Proces obaveštavanja o izmenama:</strong>
              </p>
              <ul>
                <li>
                  <strong>Manje izmene:</strong> objava na ovoj stranici sa
                  ažuriranim datumom
                </li>
                <li>
                  <strong>Značajne izmene:</strong> email obaveštenje najmanje
                  30 dana pre stupanja na snagu + istaknuto obaveštenje na
                  platformi
                </li>
                <li>
                  <strong>Izmene koje utiču na cene:</strong> pravo na povraćaj
                  po starim uslovima u roku od 14 dana
                </li>
              </ul>
              <p>
                Nastavak korišćenja MITOVKA Beautyspot platforme nakon stupanja
                izmena na snagu smatra se vašim prihvatanjem novih uslova
                korišćenja.
              </p>
              <p>Ako se ne slažete sa izmenama, imate pravo da:</p>
              <ul>
                <li>Prestanete koristiti platformu</li>
                <li>Zatražite brisanje naloga</li>
                <li>
                  Zatražite povraćaj sredstava za neiskorišćeni pristup
                  (pro-rata)
                </li>
              </ul>
            </TextContent>

            <SectionTitle>11. Važeći Zakon i Nadležnost</SectionTitle>
            <TextContent>
              <p>
                Ovi uslovi korišćenja se regulišu i tumače u skladu sa zakonima
                Republike Srbije, uključujući:
              </p>
              <ul>
                <li>Zakon o obligacionim odnosima</li>
                <li>Zakon o zaštiti potrošača</li>
                <li>Zakon o elektronskoj trgovini</li>
                <li>Zakon o autorskom i srodnim pravima</li>
                <li>Zakon o zaštiti podataka o ličnosti</li>
              </ul>
              <p>
                <strong>Rešavanje sporova:</strong>
              </p>
              <ul>
                <li>
                  <strong>Preporuka:</strong> prvo pokušajte mirnim putem kroz
                  našu korisničku podršku
                </li>
                <li>
                  <strong>Medijacija:</strong> volimo da pokušamo medijaciju pre
                  sudskog postupka
                </li>
                <li>
                  <strong>Nadležnost:</strong> svi nerazrešeni sporovi će biti
                  rešavani pred stvarno i mesno nadležnim sudovima u Beogradu,
                  Republika Srbija
                </li>
              </ul>
              <p>Za potrošačke sporove, korisnici imaju pravo da se obrate:</p>
              <ul>
                <li>Nacionalnoj organizaciji potrošača Srbije</li>
                <li>
                  Povereнiku za zaštitu ravnopravnosti (u slučaju
                  diskriminacije)
                </li>
                <li>Tržišnoj inspekciji</li>
              </ul>
            </TextContent>

            <SectionTitle>12. Kontakt i Podrška</SectionTitle>
            <TextContent>
              <p>
                Za sva pitanja, primedbe ili pomoć vezanu za ove uslove
                korišćenja ili korišćenje platforme, možete nas kontaktirati:
              </p>
              <ul>
                <li>Putem kontakt forme na platformi</li>
                <li>Email-om (dostupan na kontakt stranici)</li>
              </ul>
              <p>
                Trudimo se da odgovorimo na sve upite u roku od 48 sati radnim
                danima.
              </p>
              {/* <p>
                <strong>Radno vreme podrške:</strong> ponedeljak - petak, 09:00
                - 17:00 (CET)
              </p> */}
            </TextContent>

            <SectionTitle>13. Razno</SectionTitle>
            <TextContent>
              <p>
                <strong>Deljljivost odredbi:</strong> Ako se bilo koja odredba
                ovih uslova smatra nevažećom ili neizvršivom, ostale odredbe
                ostaju na snazi.
              </p>
              <p>
                <strong>Potpunost sporazuma:</strong> Ovi uslovi, zajedno sa
                Politikom privatnosti, čine potpun sporazum između vas i MITOVKA
                Beautyspot.
              </p>
              <p>
                <strong>Odricanje:</strong> Neuspeh da se insistira na bilo
                kojoj odredbi ne znači odricanje od te odredbe.
              </p>
              <p>
                <strong>Ustupanje:</strong> Ne možete preneti svoja prava ili
                obaveze iz ovih uslova bez naše pisane saglasnosti.
              </p>
              <p>
                <strong>Jezik:</strong> U slučaju neslaganja između verzija na
                različitim jezicima, verzija na srpskom jeziku ima prednost.
              </p>
            </TextContent>

            <LastUpdated>
              <strong>Poslednja izmena:</strong> 10. februar 2026.
            </LastUpdated>
          </ContentContainer>
        </ContentSection>
      </Container>
    </MainContainer>
  );
};

export default TermsOfServicePage;
